import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import api from '../../../const/axios'

const pretty = (obj: any) => JSON.stringify(obj, null, 2)

const RatingAdminResults: React.FC = () => {
  const [message, setMessage] = useState('')
  const [error, setError] = useState('')
  const [resultTournamentId, setResultTournamentId] = useState('')
  const [resultsJson, setResultsJson] = useState(pretty({
    eventDate: new Date().toISOString(),
    gameType: 'CHGK',
    ageCategoryTags: ['adult'],
    teams: [],
  }))

  const handleSubmitResults = async () => {
    setMessage('')
    setError('')
    try {
      const payload = JSON.parse(resultsJson)
      const res = await api.post(`/tournaments/${resultTournamentId}/results`, payload)
      setMessage(`Nəticələr qəbul edildi: ${pretty(res.data)}`)
    } catch (err: any) {
      setError(err?.response?.data || 'Nəticə göndərilməsi uğursuz oldu.')
    }
  }

  const input = 'w-full border border-slate-200 dark:border-gray-700 bg-white dark:bg-gray-800 text-gray-800 dark:text-gray-100 placeholder:text-gray-400 dark:placeholder:text-gray-500 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500/40'

  return (
    <div className="min-h-screen bg-slate-50 pt-16">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8 space-y-4">
        <div className="flex justify-between items-center">
          <h1 className="text-2xl font-black text-slate-900">Manual results JSON</h1>
          <Link to="/ratings/admin" className="text-sm text-blue-700 dark:text-indigo-300">Panel home</Link>
        </div>

        {message ? <pre className="text-xs text-emerald-800 bg-emerald-50 border border-emerald-200 p-3 rounded-lg overflow-auto">{message}</pre> : null}
        {error ? <p className="text-sm text-red-600">{String(error)}</p> : null}

        <section className="bg-white dark:bg-gray-900 rounded-2xl border border-slate-100 shadow-sm p-4 space-y-3">
          <input className={input} placeholder="Tournament ID" value={resultTournamentId} onChange={(e) => setResultTournamentId(e.target.value)} />
          <textarea className={`${input} min-h-[260px] font-mono text-xs`} value={resultsJson} onChange={(e) => setResultsJson(e.target.value)} />
          <button onClick={handleSubmitResults} className="bg-blue-700 text-white px-3 py-2 rounded-lg text-sm font-semibold">Nəticəni göndər</button>
        </section>
      </div>
    </div>
  )
}

export default RatingAdminResults
